import React, { Component } from 'react';
import { Group, Rect, Image } from 'react-konva';

export class SchematicMapComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const resizedWidth = geometry.width * dimentionsRatio;
        const resizedHeight = geometry.height * dimentionsRatio;
        
        let fontSize = resizedHeight * 0.8;
        if(fontSize > resizedWidth) {
            fontSize = resizedWidth - 10;
        }

        const image = new window.Image();
        image.src = process.env.PUBLIC_URL + '/icons/schematicmap.png';

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={resizedWidth}
                    height={resizedHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />
                <Image
                    x={geometry.drawPositionX + resizedWidth / 2.0}
                    y={geometry.drawPositionY + resizedHeight / 2.0}
                    image={image}
                    width={resizedWidth}
                    height={resizedHeight}
                    offsetX={(resizedWidth) / 2}
                    offsetY={(resizedHeight) / 2} />
            </Group>
        );
    }
}
